// extracted by mini-css-extract-plugin
export default {"block":"FunBlock_block_Iflzs","content":"FunBlock_content_alTT1","cover":"FunBlock_cover_JFCdp","subtitle":"FunBlock_subtitle_xX7rl"};